import { useEffect, useId } from 'react';
import { releaseGlobalHotkeys, suppressGlobalHotkeys } from './globalHotkeysStore';

/**
 * Suppresses global hotkeys for as long as the calling component is mounted.
 *
 * Pass a condition for surfaces that mount before they're visible.
 * @param isDisabled whether to suppress right now
 */

export function useDisableGlobalHotkeys(isDisabled = true): void {
  const token = useId();

  useEffect(() => {
    if (!isDisabled) {
      return;
    }
    suppressGlobalHotkeys(token);
    return () => releaseGlobalHotkeys(token);
  }, [isDisabled, token]);
}
